export type TimelineEventKind = 'DRAFT_SAVED' | 'SIGNED' | 'ADDENDUM_ADDED';

export interface TimelineEvent {
  id: string;
  kind: TimelineEventKind;
  timestamp: string;
  actorName: string;
  reportUuid: string;
  isCurrent: boolean;
  statusTags: string[];
}

/** A group of consecutive draft-saved events collapsed into one entry. */
export interface DraftGroup {
  type: 'draft-group';
  id: string;
  latestEvent: TimelineEvent;
  events: TimelineEvent[];
}

/** Discriminated union for rendering timeline rows. */
export type TimelineEntry = TimelineEvent | DraftGroup;

export function isDraftGroup(entry: TimelineEntry): entry is DraftGroup {
  return 'type' in entry && entry.type === 'draft-group';
}
